import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/images/ATS.png";
import ios from "../../assets/mobil/ios.png";
import google from "../../assets/mobil/google.png";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="Has Gümüş  Logo" className="footer-logo" />
        </div>
        <div className="footer-right">
          <div className="footer-menu">
            <Link to="/" className="footer-menu-item">Ana Sayfa</Link>
            <Link to="/about" className="footer-menu-item">Hakkımızda</Link>
            <Link to="/products" className="footer-menu-item">Bilgi Toplum Hizmetleri</Link>
            <Link to="/contact" className="footer-menu-item">İletişim</Link>
          </div>
          <p className="footer-text">
            AIFASOFT © 2024 Tüm hakları saklıdır.
          </p>
          <p className="footer-info">
            Tüm kurlar bilgi amaçlıdır ve piyasa verileri Foreks Hizmetleri tarafından sağlanmaktadır.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/us/app/ats-exchange/id6744863087" target="_blank" rel="noopener noreferrer">
              <img src={ios} alt="App Store" className="store-icon" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.aifasoft.atsdoviz&hl=tr" target="_blank" rel="noopener noreferrer">
              <img src={google} alt="Google Play" className="store-icon" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;